import { createContext, useReducer } from "react";
import dataConstants from "../../constants/dataConstants";
import OrderStepsReducer from "../reducers/OrderStepsReducer";

export const OrderStepsContext = createContext<any>({
  orderSteps: dataConstants.onlineOrderFormSteps
})

function OrderStepsProvider({ children }: { children: React.ReactNode }) {
  const [state, dispatch] = useReducer<any>(OrderStepsReducer, { orderSteps: dataConstants.onlineOrderFormSteps })
  return <OrderStepsContext.Provider value={{ state, dispatch }}>
    {children}
  </OrderStepsContext.Provider>
}

export default OrderStepsProvider